import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface TrialStatusCount {
  status: string;
  count: number;
}

interface TrialStatusFilters {
  startDate?: string;
  endDate?: string;
}

export function useTrialStatusCounts(filters?: TrialStatusFilters) {
  return useQuery({
    queryKey: ['trial-status-counts', filters?.startDate, filters?.endDate],
    queryFn: async () => {
      let query = supabase.from('v_trial_courses').select('status');
      
      if (filters?.startDate) {
        query = query.gte('class_date', filters.startDate);
      }
      if (filters?.endDate) {
        query = query.lte('class_date', filters.endDate);
      }
      
      const { data, error } = await query;
      
      if (error) throw error;
      if (!data) return [];

      // Count by status
      const counts = data.reduce((acc, row) => {
        const status = row.status || 'ไม่ระบุ';
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {} as Record<string, number>);

      // Convert to array and sort by count descending
      const result: TrialStatusCount[] = Object.entries(counts)
        .map(([status, count]) => ({ status, count }))
        .sort((a, b) => b.count - a.count);

      return result;
    }
  });
}
